export default __webpack_public_path__ + "static/media/twitter.770df5a5.svg";